import React from "react";

// Shared button primitive. Variants map to the .btn-* classes in index.css.
//   <Button variant="primary|secondary|ghost|accent|danger" size="sm|md|lg">
const VARIANTS = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  ghost: "btn-ghost",
  accent: "btn-accent",
  danger: "btn-danger",
};
const SIZES = { sm: "btn-sm", md: "", lg: "btn-lg" };

export default function Button({
  variant = "primary",
  size = "md",
  className = "",
  type = "button",
  children,
  ...props
}) {
  const cls = [VARIANTS[variant] || VARIANTS.primary, SIZES[size] || "", className]
    .filter(Boolean)
    .join(" ");
  return (
    <button type={type} className={cls} {...props}>
      {children}
    </button>
  );
}
